import ajax from "./util-ajax";

const jQuery = window.jQuery;

const ajaxGet = {
  getCampaign: getCampaign,
  getCampaigns: getCampaigns,
  getChangeLog: getChangeLog,
  getConflicts: getConflicts,
  getException: getException,
  getIntegrations: getIntegrations,
  getInterstitialsByDay: getInterstitialsByDay,
  getInterstitialsByTimeslot: getInterstitialsByTimeslot,
  getInterstitialsByWeek: getInterstitialsByWeek,
  getInvoiceCustomizations: getInvoiceCustomizations,
  getInvoiceDefaults: getInvoiceDefaults,
  getLivestreamData: getLivestreamData,
  getPod: getPod,
  getPods: getPods,
  getPodStatus: getPodStatus,
  getPodsNotifications: getPodsNotifications,
  getPodsForCampaign: getPodsForCampaign,
  getReports: getReports,
  getReportsCSV: getReportsCSV,
  getReportsPDF: getReportsPDF,
  getRoles: getRoles,
  getRule: getRule,
  getRules: getRules,
  getS3Url: getS3Url,
  getScheduleByDay: getScheduleByDay,
  getScheduleByWeek: getScheduleByWeek,
  getSchedulesInterstitialsCSV: getSchedulesInterstitialsCSV,
  getSearchResults: getSearchResults,
  getShows: getShows,
  getSpot: getSpot,
  getSpots: getSpots,
  getSpotsForPod: getSpotsForPod,
  getStation: getStation,
  getStationChangeLog: getStationChangeLog,
  getStationIntegrations: getStationIntegrations,
  getStationInvites: getStationInvites,
  getStationInvite: getStationInvite,
  getStationUsers: getStationUsers,
  getStationUser: getStationUser,
  getUser: getUser
};

export default ajaxGet;

//

function getCampaign(campaignId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/campaigns/${campaignId}/`
    })
    .fail(ajax.onFail);
}

function getCampaigns(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        ordering: config.sort,
        page: config.page,
        search: config.search
      },
      method: `get`,
      url: `/api/campaigns/`
    })
    .fail(ajax.onFail);
}

function getChangeLog(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        page: config.page,
        sort: config.sort
      },
      method: `get`,
      url: `/api/history/all/${config.contentType}/${config.id}/`
    })
    .fail(ajax.onFail);
}

function getConflicts() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/conflicts/`
    })
    .fail(ajax.onFailWithExceptions);
}

function getException(id) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/rules/exceptions/${id}/`
    })
    .fail(ajax.onFail);
}

function getIntegrations() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/integrations/`
    })
    .fail(ajax.onFail);
}

function getInterstitialsByDay(day) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/interstitials/day/${day}/`
    })
    .fail(ajax.onFail);
}

function getInterstitialsByTimeslot(timeslot, start, days = 7) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        start: start,
        days: days
      },
      method: `get`,
      url: `/api/interstitials/timeslot/${timeslot}/`
    })
    .fail(ajax.onFail);
}

function getInterstitialsByWeek(sunday) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/interstitials/week/${sunday}/`
    })
    .fail(ajax.onFail);
}

function getPod(podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/pods/${podId}/`
    })
    .fail(ajax.onFail);
}

function getPods(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        ordering: config.sort,
        page: config.page,
        search: config.search,
        aws_status: config.aws_status,
        unused: config.unused
      },
      method: `get`,
      url: `/api/pods/`
    })
    .fail(ajax.onFail);
}

function getPodStatus(podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/pods/status/${podId}/`
    })
    .fail(ajax.onFail);
}

function getPodsNotifications(podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: podId
        ? `/api/pods/notifications/?pod_id=${podId}`
        : `/api/pods/notifications/`
    })
    .fail(ajax.onFail);
}

function getPodsForCampaign(campaignId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        ordering: `name`
      },
      method: `get`,
      url: `/api/campaigns/${campaignId}/pods/`
    })
    .fail(ajax.onFail);
}

function getReports(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        end: config.end,
        page: config.page,
        start: config.start,
        field: config.field,
        q: config.search
      },
      method: `get`,
      url: `/api/reports/`
    })
    .fail(ajax.onFail);
}

function getInvoiceCustomizations() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/reports/station-customizations/`
    })
    .fail(ajax.onFail);
}

function getInvoiceDefaults() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/reports/station-defaults/`
    })
    .fail(ajax.onFail);
}

function getReportsCSV(config) {
  // trigger the file download;
  // no, this isn't an Ajax call, but it's the only one of the app;
  return `/api/reports/download/?field=${config.field}&q=${config.search}&start=${config.start}&end=${config.end}`;
}

function getReportsPDF(config) {
  // trigger the file download;
  // no, this isn't an Ajax call, but it's the only one of the app;
  return (
    `/api/reports/download/pdf/?` +
    `field=${config.field}&q=${config.search}&start=${config.start}&end=${config.end}` +
    `&invoice_number=${config.invoiceNumber}&invoice_date=${config.invoiceDate}` +
    `&customer_name=${config.customerName}&company_name=${config.companyName}` +
    `&company_address=${config.companyAddress}&company_city=${config.companyCity}` +
    `&invoice_description=${config.invoiceDescription}` +
    `&cost_per_view=${config.costPerView}` +
    `&pods_ordered_by_date=${config.podsOrderedByDate}` +
    `&pods_ordered_by_name=${config.podsOrderedByName}` +
    `&columns_to_include_airtime=${config.columnsToIncludeAirtime}` +
    `&columns_to_include_pod_name=${config.columnsToIncludePodName}` +
    `&columns_to_include_shown_after=${config.columnsToIncludeShownAfter}` +
    `&columns_to_include_shown_before=${config.columnsToIncludeShownBefore}` +
    `&columns_to_include_view_count=${config.columnsToIncludeViewCount}`
  );
}

function getSchedulesInterstitialsCSV(startDate, endDate) {
  // trigger the file download;
  return `/api/schedules_interstitials/download/?start_date=${startDate}&end_date=${endDate}`;
}

function getRoles() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/groups/`
    })
    .fail(ajax.onFail);
}

function getRule(ruleId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/rules/${ruleId}/`
    })
    .fail(ajax.onFail);
}

function getRules(config) {
  // status and timeslot are tracked differently on the FE;
  // all is not a valid BE value, but it is for the FE;
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        ordering: config.sort,
        page: config.page,
        search: config.search,
        state: config.status === `all` ? null : config.status,
        timeslot: config.timeslot === `All` ? null : config.timeslot
      },
      method: `get`,
      url: `/api/rules/`
    })
    .fail(ajax.onFail);
}

function getS3Url(report) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      method: `post`,
      data: JSON.stringify(report),
      url: `/api/files/sign-file/?format=json`
    })
    .fail(ajax.onFail);
}

function getScheduleByDay(day) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/schedules/day/${day}/`
    })
    .fail(ajax.onFail);
}

function getScheduleByWeek(sunday) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/schedules/week/${sunday}/`
    })
    .fail(ajax.onFail);
}

function getSearchResults(searchTerm, type) {
  return jQuery.when(
    jQuery.ajax({
      beforeSend: ajax.beforeSend,
      data: {
        ordering: `name`,
        page: 1,
        search: searchTerm
      },
      method: `get`,
      url: `/api/${type}/`
    })
  );
}

function getShows(config) {
  return jQuery.when(
    jQuery.ajax({
      beforeSend: ajax.beforeSend,
      data: {
        search: config.searchTerm,
        exclude: config.excludeShows
      },
      method: `get`,
      url: `/api/shows/`
    })
  );
}

function getSpot(spotId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/spots/${spotId}/`
    })
    .fail(ajax.onFail);
}

function getSpots(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        ordering: config.sort,
        page: config.page,
        search: config.search,
        aws_status: config.aws_status,
        unused: config.unused,
        exclude: config.exclude
      },
      method: `get`,
      url: `/api/spots/`
    })
    .fail(ajax.onFail);
}

function getSpotsForPod(podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/pods/${podId}/spots/`
    })
    .fail(ajax.onFail);
}

function getStation() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/station/`
    })
    .fail(ajax.onFail);
}

function getStationChangeLog(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        page: config.page,
        sort: config.sort
      },
      method: `get`,
      url: `/api/history/all/`
    })
    .fail(ajax.onFail);
}

function getStationIntegrations() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/station/integrations/`
    })
    .fail(ajax.onFail);
}

function getStationInvites(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        page: config.page
      },
      method: `get`,
      url: `/api/station/invites/`
    })
    .fail(ajax.onFail);
}

function getStationInvite(id) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/station/invites/${id}/`
    })
    .fail(ajax.onFail);
}

function getStationUsers(config) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      data: {
        page: config.page
      },
      method: `get`,
      url: `/api/station/users/`
    })
    .fail(ajax.onFail);
}

function getStationUser(id) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/station/users/${id}/`
    })
    .fail(ajax.onFail);
}

function getUser() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/user/`
    })
    .fail(ajax.onFailWithExceptions);
}

function getLivestreamData() {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      method: `get`,
      url: `/api/livestream/`
    })
    .fail(ajax.onFail);
}
